Object.defineProperty(exports,"__esModule",{value:true});var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=require("react");var _react2=_interopRequireDefault(_react);
var _index=require("../victory-util/index");function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var



ClipPath=function(_React$Component){_inherits(ClipPath,_React$Component);function ClipPath(){_classCallCheck(this,ClipPath);return _possibleConstructorReturn(this,(ClipPath.__proto__||Object.getPrototypeOf(ClipPath)).apply(this,arguments));}_createClass(ClipPath,[{key:"componentWillMount",value:function componentWillMount()

































{var _calculateAttributes=
this.calculateAttributes(this.props),x=_calculateAttributes.x,y=_calculateAttributes.y,width=_calculateAttributes.width,height=_calculateAttributes.height;
this.x=x;
this.y=y;
this.width=width;
this.height=height;
}},{key:"shouldComponentUpdate",value:function shouldComponentUpdate(

nextProps){var _calculateAttributes2=
this.calculateAttributes(nextProps),x=_calculateAttributes2.x,y=_calculateAttributes2.y,width=_calculateAttributes2.width,height=_calculateAttributes2.height;var
clipId=this.props.clipId;
if(
x!==this.x||
y!==this.y||
width!==this.width||
height!==this.height||
clipId!==nextProps.clipId)
{
this.x=x;
this.y=y;
this.width=width;
this.height=height;
return true;
}
return false;
}},{key:"calculateAttributes",value:function calculateAttributes(

props){var

clipWidth=



props.clipWidth,clipHeight=props.clipHeight,translateX=props.translateX,clipPadding=props.clipPadding;

var padding=_index.Helpers.getPadding(props);

var totalPadding=function totalPadding(side){
var total=+padding[side]-(clipPadding[side]||0);
return typeof total==="number"?total:0;
};

return{
x:totalPadding("left")+translateX,
y:totalPadding("top"),
width:Math.max(+clipWidth-totalPadding("left")-totalPadding("right"),0),
height:Math.max(+clipHeight-totalPadding("top")-totalPadding("bottom"),0)};

}},{key:"renderClipPath",value:function renderClipPath(


props,id){
return(
_react2.default.createElement("defs",null,
_react2.default.createElement("clipPath",{id:id},
_react2.default.createElement("rect",props))));



}},{key:"render",value:function render()

{var _props=
this.props,clipId=_props.clipId,className=_props.className;
var clipProps={className:className,x:this.x,y:this.y,width:this.width,height:this.height};
return this.renderClipPath(clipProps,clipId);
}}]);return ClipPath;}(_react2.default.Component);ClipPath.propTypes={className:_react.PropTypes.string,clipId:_react.PropTypes.number,clipPadding:_react.PropTypes.shape({top:_react.PropTypes.number,bottom:_react.PropTypes.number,left:_react.PropTypes.number,right:_react.PropTypes.number}),clipHeight:_index.PropTypes.nonNegative,clipWidth:_index.PropTypes.nonNegative,padding:_react.PropTypes.oneOfType([_react.PropTypes.number,_react.PropTypes.shape({top:_react.PropTypes.number,bottom:_react.PropTypes.number,left:_react.PropTypes.number,right:_react.PropTypes.number})]),translateX:_react.PropTypes.number};ClipPath.defaultProps={translateX:0,clipPadding:{top:5,bottom:5,left:0,right:0}};exports.default=ClipPath;


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-primitives/clip-path.js
// module id = 1414
// module chunks = 0